<template>
  <div class="a7-aplicacao">
    <gw-nav-bar :categories="menu">
      <template slot="end">
        <a7-sessao-usuario/>
      </template>
    </gw-nav-bar>
    <div class="a7-aplicacao-router-view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {
    GwNavBar
} from 'guaxinim-web';
import A7SessaoUsuario from '@/components/painel/A7SessaoUsuario';

export default {
  name: "a7-aplicacao",
  components: {
    GwNavBar,
    A7SessaoUsuario
  },
  data() {
    return {
      menu: this.$menu
    }
  }
}
</script>

<style lang="scss" scoped>
.a7-aplicacao {
  height: 100vh;

  .gw-nav-bar {
    z-index: 20;
  }

  .a7-aplicacao-router-view {
    position: absolute;
    top: 56px;
    bottom: 0;
    width: 100%;
    overflow-y: auto;
  }
}
</style>
